<!--suppress CssUnusedSymbol -->
<template lang="pug">
  #alert-panel-switcher(@click="$emit('clicked')" :class="css_class")
    .alert-panel-switcher--info-wrapper
      icon-mdi(:icon="icon")

</template>

<script>
import { mdiCommentAlert } from '@mdi/js';
import { mdiCommentOutline } from '@mdi/js';
import { mdiCheck } from '@mdi/js';
import { mdiWindowClose } from '@mdi/js';
import IconMdi from "../icons/IconMdi";
export default {
name: "alertPanelSwitcher",
  components: {IconMdi},
  props:['panel_state'],
  data(){
    return {
      icon_new_alerts: mdiCommentAlert,
      icon_all_read: mdiCommentOutline,
      icon_empty: mdiCheck,
      icon_close: mdiWindowClose,
    }
  },
  computed:{
    new_alerts(){
      return this.$store.getters['alerts/newAlerts'].length
    },
    all_alerts(){
      return this.$store.getters['alerts/allAlerts'].length
    },
    icon(){
      if (this.panel_state === 'opened') return this.icon_close;
      if (this.new_alerts > 0) return this.icon_new_alerts;
      if (this.all_alerts > 0) return this.icon_all_read;
      return this.icon_empty;
    },
    css_class(){
      return `${this.css_by_alerts} ${this.css_by_panel_state}`;
    },
    css_by_alerts(){
      if (this.new_alerts > 0) return 'danger';
      if (this.all_alerts > 0) return 'normal';
      return 'empty';
    },
    css_by_panel_state(){
      if (this.panel_state === 'just_now') return 'just';

      return '';

    }

  }
}
</script>

<style scoped>
  #alert-panel-switcher{
    transition: all .3s ease;
    position: absolute;
    left: -75px;
    top: 85px;
    height: 50px;
    width: 50px;
    border-radius: 25px;
    background-color: #7a6dd7;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
  }
  #alert-panel-switcher.danger{
    background-color: #d3290b;
  }
  #alert-panel-switcher:hover{
    left: -65px;
  }
  #alert-panel-switcher.just{
    top: 25px;
    left: -425px;
  }
  #alert-panel-switcher.just:hover{
    left: -415px;
  }

  .alert-panel-switcher--info-wrapper{
    height: 20px;
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

</style>